import React from 'react';
import { Typography } from 'antd';
import type { PendingApproverDTO } from '@/services/approval.service';

const { Text } = Typography;

export interface PendingApproverTextProps {
  pendingApproverLabel?: string | null;
  pendingApprovers?: PendingApproverDTO[];
  compact?: boolean;
  prefix?: string;
}

export const PendingApproverText: React.FC<PendingApproverTextProps> = ({
  pendingApproverLabel,
  pendingApprovers,
  compact = false,
  prefix = 'Next approver',
}) => {
  const label =
    pendingApproverLabel?.trim() ||
    (pendingApprovers?.length
      ? pendingApprovers
          .map((a) => {
            if (a.assignee_type === 'user') {
              const name = a.full_name?.trim() || 'Unknown user';
              const base = a.email ? `${name} (${a.email})` : name;
              const delegates = (a.delegates || []).map((d) => d.full_name?.trim() || d.email).filter(Boolean);
              return delegates.length ? `${base} — delegate: ${delegates.join(', ')}` : base;
            }
            const role = a.role_name?.trim() || 'Role';
            const members = (a.role_members || []).map((m) => m.full_name?.trim() || m.email).filter(Boolean);
            return members.length ? `${role}: ${members.join(', ')}` : role;
          })
          .join('; ')
      : '');

  if (!label) return null;

  if (compact) {
    return (
      <Text type="secondary" style={{ display: 'block', fontSize: 12, lineHeight: 1.3 }}>
        {prefix}: {label}
      </Text>
    );
  }

  return (
    <Text type="secondary">
      {prefix}: {label}
    </Text>
  );
};
